/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MercerStandingJobCode } from './mercer-standing-job-code';

export interface MercerStanding {
  id?: string;
  employeeId?: string;
  positionClass?: number | null;
  originalProposedPositionClass?: number | null;
  positionClassDeviationReason?: string | null;
  superiorPositionClass?: number | null;
  jobCodeId?: string | null;
  state?: MercerStandingStateEnum;
  approvedAt?: string | null;
  startedAt?: string | null;
  jobCode?: MercerStandingJobCode;
  isGermanPartialEvaluation?: boolean;
  orgSize?: number | null;
  orgLevel?: number | null;
  positionClassValidFrom?: string | null;
  jobCodeValidFrom?: string | null;
  latestValidatedJobCode?: string | null;
  latestValidatedPositionClass?: number | null;
  isHrEditDisabled?: boolean;
  /**
   * True when the employee security settings mark the position evaluation as read only for the requester\'s role. The evaluation stays visible, but must not be edited or reopened.
   */
  isCpeReadonly?: boolean;
  isPromotionAllowed?: boolean;
  wasPromoted?: boolean;
  showWasPromoted?: boolean;
}
export enum MercerStandingStateEnum {
  Open = 'Open',
  RequestedHr = 'RequestedHR',
  RequestedCb = 'RequestedCB',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
